import React, { useEffect, useState } from "react";
import { FaTimes, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const Popup = ({ mode = "popup" }) => {
  const [open, setOpen] = useState(mode === "page");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const phoneNumber = "919582730030";
  const receiverEmail = "pcenterprises25@gmail.com";

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  useEffect(() => {
    if (mode === "popup") {
      const timer = setTimeout(() => setOpen(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [mode]);

  if (!open) return null;

  const buildMessage = () => {
    return `Name: ${name || "Not provided"}

Message:
${message || "Hello, I would like to enquire about your export products."}

Date: ${new Date().toLocaleString()}`;
  };

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    buildMessage()
  )}`;

  const handleEmail = () => {
    if (!name.trim()) {
      alert("Name is required");
      return;
    }

    const subject = "Website Enquiry - PC Enterprises";
    const body = buildMessage();

    if (isMobile) {
      window.location.href = `mailto:${receiverEmail}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
    } else {
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${receiverEmail}&su=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;

      window.open(gmailUrl, "_blank");
    }

    if (mode === "popup") setOpen(false);
  };

  return (
    <div
      className={
        mode === "popup"
          ? "fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4 py-6"
          : "w-full"
      }
    >
      <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl relative">

        {/* Header */}
        <div className="bg-black px-6 py-4 text-white text-center rounded-t-2xl">
          <h2 className="text-xl font-bold">Enquiry Form</h2>
          <p className="text-sm text-gray-300 mt-1">
            Let us know what you're looking for.
          </p>
        </div>

        {/* Close */}
        {mode === "popup" && (
          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 text-white text-lg"
          >
            <FaTimes />
          </button>
        )}

        {/* Form */}
        <div className="px-6 py-5 space-y-4">

          <input
            type="text"
            placeholder="Your Name *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-black outline-none"
          />

          <textarea
            rows="3"
            placeholder="Your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-black outline-none resize-none"
          />

          <div className="grid grid-cols-2 gap-3">

            <button
              onClick={handleEmail}
              className="flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg font-semibold transition"
            >
              <FaEnvelope /> Email
            </button>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => mode === "popup" && setOpen(false)}
              className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg font-semibold transition"
            >
              <FaWhatsapp /> WhatsApp
            </a>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;